import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const GoogleDriveIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.55 2.5H9.5C9.21667 2.5 8.92917 2.5875 8.6375 2.7625C8.34583 2.9375 8.13333 3.14167 8 3.375L1.75 14.525C1.61667 14.7583 1.55 15.0458 1.55 15.3875C1.55 15.7292 1.61667 16.0167 1.75 16.25L4.25 20.625C4.35678 20.8119 4.51434 20.98 4.72267 21.1295C4.79955 21.2245 4.89525 21.3069 5.00812 21.3707C5.20007 21.4792 5.41264 21.5174 5.61605 21.4935C5.66081 21.4978 5.70546 21.5 5.75 21.5H18.3C18.5833 21.5 18.8708 21.4125 19.1625 21.2375C19.4542 21.0625 19.6667 20.8583 19.8 20.625L22.3 16.25C22.4333 16.0167 22.5 15.7292 22.5 15.3875C22.5 15.0458 22.4333 14.7583 22.3 14.525L16.05 3.375C15.9167 3.14167 15.7042 2.9375 15.4125 2.7625C15.1208 2.5875 14.8333 2.5 14.55 2.5ZM7.21417 19.5H18.15L20.156 16.0002H9.1923L7.21417 19.5ZM19.7167 14.0002L14.4 4.5H10.5036L16.5492 14.0002H19.7167ZM8.94015 5.76843L3.55 15.4L5.40497 18.6363L10.9198 8.87932L8.94015 5.76843ZM14.1786 14.0002H10.3227L12.1365 10.7913L14.1786 14.0002Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
